import { render, staticRenderFns } from "./goods1.vue?vue&type=template&id=2ffa5f60&scoped=true"
import script from "./goods1.vue?vue&type=script&lang=js"
export * from "./goods1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffa5f60",
  null
  
)

export default component.exports